// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3YcZG","chevron":"footer-module--chevron--1ODkp","down":"footer-module--down--3zgKv"};